import React, {Fragment, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import Breadcrumb from '../../../../layout/breadcrumb'
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody, FormGroup, Label, Form, Button,
    Alert
} from 'reactstrap'
import {optionDefaultValue, BASE_CURRENCY, CURRENCY_SYMBOL} from "../../../../utils/common";
import withReducer from "../../../../store/withReducer";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";

import {useHistory, useParams} from "react-router-dom";
import PreLoader from "../../../../share-components/ui/preLoader";
import draftOrderReducer from "../../store";
import {
    addDraftOrders, closeNewAddressDialog, getCountryList, getCountryListData,
    getCustomerAddressData,
    getDraftOrder, openEditAddressDialog,
    setSearchProductDialog,
    updateDraftOrder
} from "../../store/draftOrderSlice";
import SearchProductModal from "./content/searchProductModal";
import OrderProductJqx from "./content/orderProductJqx";
import {mapSearchAutoSuggestion} from "../../../../utils/mapper";
import {customerAutoSuggestionApi} from "../../../../services/order";
import AsyncSelect from "react-select/async";
import TagsInput from "react-tagsinput";
import OrderPayment from "./content/orderPayment";

import OrderDiscount from "./content/orderDiscount";
import OrderShipment from "./content/orderShipment";
import OrderTax from "./content/orderTax";
import BuyerLeadAddressForm from "../../../leads/form/buyerLeadAddressForm";
import ModalFormSubmit from "../../../../share-components/form/modalFormSubmit";
import Select from "react-select";
import DraftOrderAddressForm from "./buyerLeadAddressForm";
import {getBuyerLeadSettings, setSettings} from "../../../leads/store/buyerLeadSlice";
import {toast} from "react-toastify";


export const CURRENCY_OPTIONS = [
    { value: BASE_CURRENCY, label: `${BASE_CURRENCY} (${CURRENCY_SYMBOL})`, symbol: CURRENCY_SYMBOL, rate: 1 },
    { value: 'GBP', label: 'GBP (£)', symbol: '£', rate: 1 },
    { value: 'EUR', label: 'EUR (€)', symbol: '€', rate: 1.35 },
    { value: 'USD', label: 'USD ($)', symbol: '$', rate: 2 },
];

/**
 * Apply currency-specific rounding rules to a converted price.
 * USD: round to nearest whole number
 * EUR: round up to nearest .95 (charm pricing)
 * GBP/other: round to 2 decimal places
 */
export const applyPriceRounding = (convertedPrice, currencyValue) => {
    if (currencyValue === 'EUR') {
        return Math.ceil(convertedPrice - 0.95) + 0.95;
    }
    return parseFloat(convertedPrice.toFixed(2));
};

const defaultValues = {
    id: '',
    ordered_products: [],
    ordered_products_new: [],
    tags: [],
    notes: "",
    discount: "",
    shipping: "",
    tax:"",
    is_tax: false,
    is_paid:false,
    customer:"",
    shopify_draft_order_id:"",
    shippingAddress:'',
    billingAddress:'',
    price_change_reason:'',
};

export const defaultAddressValues = {
    company:'',
    type:'',
    country: '',
    first_name: '',
    last_name:'',
    address1: '',
    address2: '',
    city:"",
    zip:'',
    phone:'',
    province:'',
    order_no:''
};

/**
 * Form Validation Schema
 */
const schema = yup.object().shape({
    customer: yup.object().shape({value: yup.string(),}).nullable().required('You must select a customer.'),
    shipping: yup.object().shape({rate_name: yup.string(),}).required("shipment is required").typeError('shipment is required'),
});

const dataMenu = [
    {
        type: 1,
        text: 'Draft Order',
        link: '/order/draft'
    },
    {
        type: 0,
        text: "Draft Order Form"
    }
];

export const addresSchema = yup.object().shape({
    address1: yup.string().required("Address line 1 is required").typeError('Address line 1 is required'),
    city: yup.string().required("City is required").typeError('City is required'),
    zip: yup.string().required("Zip is required").typeError('Zip is required'),
    country: yup.string().required('Country is required field').typeError('Please select Country'),
    province: yup.string().nullable().when('country', {
        is: 'India',
        then: (schema) => schema.required('State is required').typeError('State is required'),
    }),
    phone: yup.string().nullable().matches(/^.{0}$|^.{9,10}$/, 'Phone must be empty or have 9 or 10 characters'),
});

const DraftOrderForm = () => {
    const {id} = useParams();
    const dispatch = useDispatch();
    let history = useHistory();
    const [loading, setLoading] = useState(true);
    const [buttonDisable, setButtonDisable] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);

    let searchProductRef = useRef();
    const [priceValid, setPriceValid] = useState([]);
    const [qtyValid, setQtyValid] = useState([]);
    const [shippingAddress, setShippingAddress] = useState([]);
    const [billingAddress, setBillingAddress] = useState([]);
    const [type, setType] = useState(1);
    const [addressStatus, setAddressStatus] = useState(false);
    const [billingAddressStatus, setBillingAddressStatus] = useState(false);
    const [currency, setCurrency] = useState(CURRENCY_OPTIONS[0]);
    const [useRrp, setUseRrp] = useState(false);
    const buyerLeadState = useSelector(({lead}) => lead.buyerLead);

    const draftOrderState = useSelector(({order})=> order.draftOrder);

    const currentUser = useSelector(({authReducer}) => authReducer.data.user);
    const {handleSubmit, formState, reset, control, register, setValue, trigger, getValues, setError, clearErrors} = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    });

    const {handleSubmit:addressHandleSubmit,
        formState:addressFormState,
        control:addressControl,
        reset:addressReset,
        register:addressRegister,
        trigger:addressTrigger,
        setValue:addressSetValue,
        getValues:addressRGetValues

    } = useForm({
        mode: 'onChange',
        defaultValues:defaultAddressValues,
        resolver: yupResolver(addresSchema)
    });

    const {errors:addressErrors, addressIsDirty} = addressFormState;
    const {errors, isDirty} = formState;

    const priceAlertStyle = {
        listStyleType: "initial",
        paddingLeft: "inherit"
    };

    useEffect(() => {
        if (id) {
            dispatch(getDraftOrder(id)).then(res => {
                if (!res.error) {
                    // Restore currency state
                    const savedCurrency = CURRENCY_OPTIONS.find(c => c.value === res.payload.currency) || CURRENCY_OPTIONS[0];
                    setCurrency(savedCurrency);

                    // Restore RRP state
                    if (res.payload.use_rrp) {
                        setUseRrp(res.payload.use_rrp);
                    }

                    // Map products with frontend fields for price change detection
                    // original_price = catalog sale price (GBP), rrp = catalog RRP (GBP)
                    // presentment_price = price in selected currency (what user sees)
                    const rate = res.payload.conversion_rate || savedCurrency.rate;
                    const savedUseRrp = res.payload.use_rrp || false;
                    const mappedProducts = (res.payload.ordered_products || []).map(item => {
                        const baseGbp = savedUseRrp ? item.rrp : item.original_price;
                        const expectedPresentmentPrice = applyPriceRounding(baseGbp * rate, savedCurrency.value);
                        const isPriceManuallyChanged = Math.abs(expectedPresentmentPrice - item.presentment_price) >= 0.01;
                        return {
                            ...item,
                            original_base_price: item.original_price,
                            base_rrp: item.rrp,
                            // For manually changed products, store the actual GBP value of the manual price
                            base_price: isPriceManuallyChanged ? (item.presentment_price / rate) : baseGbp,
                            price: item.presentment_price,
                            total_price: item.presentment_price * item.quantity,
                            is_price_manually_changed: isPriceManuallyChanged,
                        };
                    });

                    res.payload.ordered_products = mappedProducts;
                    reset(res.payload);
                    setLoading(false);
                    setValue('ordered_products_new', mappedProducts);
                    trigger('ordered_products_new');
                }
            });
        } else {
            setLoading(false);
        }
    }, [dispatch]);

    useEffect(()=>{
        dispatch(getCountryList()).then(res => {
            dispatch(getCountryListData(res.payload));
        });
    },[dispatch])

    useEffect(() => {
        setPriceValid([]);
        setQtyValid([]);
        let price_valid = [];
        let qty_valid = [];
        getValues('ordered_products').map((item, index) => {
            if (item.price < 0) {
                price_valid.push(item);
            }

            if(item.quantity <= 0 || item.stock < item.quantity) {
                qty_valid.push(item);
            }
        });

        if (price_valid.length > 0) {
            setPriceValid(price_valid);
        }

        if(qty_valid.length > 0) {
            setQtyValid(qty_valid);
        }

    }, [getValues('ordered_products')])

    const onSubmit = (data) => {
        setButtonDisable(true);
        setPriceValid([]);
        setQtyValid([]);
        let price_valid = [];
        let qty_valid = [];
        let line_items=[];
        (data.ordered_products).map((item,index)=>{
            line_items.push({variant_id:item.variant_id,quantity:item.quantity,price:item.price});

            if(item.price < 0) {
                price_valid.push(item);
            }

            if(item.quantity <= 0 || item.stock < item.quantity) {
                qty_valid.push(item);
            }
        });

        if(price_valid.length > 0) {
            toast.error("Product price must be greater than zero.", {
                position: toast.POSITION.TOP_RIGHT,
            });
            setPriceValid(price_valid);            
            setButtonDisable(false);
            return;
        }

        if(qty_valid.length > 0) {
            toast.error("The product quantity must be greater than zero and within the available stock.", {
                position: toast.POSITION.TOP_RIGHT,
            });
            setQtyValid(qty_valid);            
            setButtonDisable(false);
            return;
        }

        const isPriceChanged = (data.ordered_products).some(item => item.is_price_manually_changed);

        if (isPriceChanged && (!data.price_change_reason || !data.price_change_reason.trim())) {
            setError('price_change_reason', {type: 'manual', message: 'Price change reason is required when product prices are modified.'});
            setButtonDisable(false);
            return;
        } else {
            clearErrors('price_change_reason');
        }

        data.ordered_products=line_items;
        data.customer=data.customer.value;
        data.currency=currency.value;
        data.use_rrp=useRrp;
        setButtonLoading(true);
        if(data.id){
            dispatch(updateDraftOrder({...data})).then(res => {
                if (!res.error) {
                    history.push('/order/draft');
                }
                setButtonDisable(false);
                setButtonLoading(false);
            });
        }else {
            dispatch(addDraftOrders({...data})).then(res => {
                if (!res.error) {
                    history.push('/order/draft');
                }
                setButtonDisable(false);
                setButtonLoading(false);
            });
        }
    }

    const openSearchProductDialog = () => {
        const obj = {props: {isOpen: true}, data: {searchValue: searchProductRef.current.value}}
        dispatch(setSearchProductDialog(obj));
    }

    const [addressArray, setAddressArray] = useState([]);
    const [fullAddressArray, setFullAddressArray] = useState([]);
    const [add, setAdd] = useState([]);
    const getCustomerAddress = (e) => {
       if (e) {
           dispatch(getCustomerAddressData(e.value)).then(res=>{
               if (res.payload) {
                   setFullAddressArray(res.payload)
                   let addressArr = [];
                   if(res.payload.length >0) {
                       res.payload.map(function (value) {
                           if (value.is_default) {
                               setAdd([{id: value.id, name: value.address1}]);
                               // setShippingAddress(value);
                               setValue('shippingAddress', value);
                               setValue('billingAddress', value);
                               addressTrigger();
                           }

                           if (res.payload.length > 1) {
                               addressArr.push({'id': value.id, 'name': value.address1})
                           }

                       });
                       setAddressArray(addressArr)
                   }else{
                       setValue('shippingAddress', {});
                       setValue('billingAddress', {});
                       addressTrigger();
                   }
                   setVatForUk();
               };
           });
       }
    }

    const setAddressData = (e) => {
        fullAddressArray.map(function (value){
            if (value.id===e.id) {
                addressReset(value);
            }
        });
    }


    const onSubmitForm = (dialog, data) => {
        if (type === 1) {
            setValue('shippingAddress', {...data});
            addressTrigger()
        } else {
            setValue('billingAddress', {...data});
            addressTrigger()
        }
        setVatForUk();
        closeDialog();
    }


    // useEffect(() => {
    //     addressSetValue('shippingAddress', shippingAddress)
    //     addressSetValue('billingAddress', billingAddress)
    // }, [shippingAddress, billingAddress]);

    const closeDialog = () => {
        dispatch(closeNewAddressDialog())
    }

    const onEdit = (editId,type) => {
        setType(type)
        const addArray = [...addressArray];
        const dataObj = {...addArray[editId], id: editId};
        const obj = {
            type: 'edit',
            isOpen: true,
            data: type===1 ? getValues('shippingAddress'): getValues('billingAddress')
        };
        // setValue('address', address)
        if (getValues('shippingAddress').first_name!== undefined || getValues('shippingAddress').first_name!== '') {
            dispatch(openEditAddressDialog(obj))
        }
    }

    const isOjectEqual=(obj1,ob2)=>{
        if(obj1 && ob2) {
            const {type: _t1, ...rest1} = obj1;
            const {type: _t2, ...rest2} = ob2;
            return JSON.stringify(rest1) === JSON.stringify(rest2);
        }else{
            return false;
        }
    }

    const typePromiseOption = (inputValue) =>
        new Promise((resolve) => {
            const data = {
                value: inputValue
            }
            setTimeout(() => {
                resolve(mapSearchAutoSuggestion(customerAutoSuggestionApi(data)))
            });
        });
        
    const sameAsShipping=()=>{
        setValue('billingAddress', {...getValues('shippingAddress')});
        setVatForUk();
        addressTrigger()
    }

    const hasPriceChanged = () => {
        const products = getValues('ordered_products');
        const reason = getValues('price_change_reason');
        const hasChangedProduct = products && products.length > 0 && products.some(item => item.is_price_manually_changed);
        const hasSavedReason = reason && reason.trim().length > 0;
        return hasChangedProduct || hasSavedReason;
    };

    const recalculateProductPrices = (newCurrency, newUseRrp) => {
        const products = getValues('ordered_products');
        if (!products || products.length === 0) return;
        const updatedProducts = products.map(product => {
            let basePrice;
            if (product.is_price_manually_changed) {
                basePrice = product.base_price;
            } else {
                basePrice = newUseRrp ? product.base_rrp : product.original_base_price;
            }
            const displayPrice = applyPriceRounding(basePrice * newCurrency.rate, newCurrency.value);
            return {
                ...product,
                base_price: basePrice,
                price: displayPrice,
                total_price: parseFloat((displayPrice * product.quantity).toFixed(2)),
            };
        });
        setValue('ordered_products', updatedProducts);
        setValue('ordered_products_new', updatedProducts);
        trigger('ordered_products');
    };

    const handleCurrencyChange = (newCurrency) => {
        setCurrency(newCurrency);
        recalculateProductPrices(newCurrency, useRrp);

        // Reset shipping, tax, and discount as their base currency values are unknown
        setValue('shipping', '');
        setValue('discount', '');
        setValue('tax', '');
        setValue('is_tax', false);
        trigger();
    };

    const handleUseRrpChange = (checked) => {
        setUseRrp(checked);
        recalculateProductPrices(currency, checked);
    };

    const setVatForUk=()=>{
        const country=optionDefaultValue(draftOrderState.settings.countries,getValues('billingAddress').country);
        if(country?.code == "GB"){
            setValue('is_tax',true);
            setValue('tax',{"is_charge":true,"rate_name":"GB VAT 20%","percentage":20});
            trigger();
        }else{
            setValue('is_tax',false);
            setValue('tax',"");
            trigger();
        }
    }
    return (
        <Fragment>
            <Breadcrumb title={`Draft Order`+(getValues('order_no')?" - "+getValues('order_no'):"")} data={dataMenu}/>
            <Container fluid={true}>
                {loading ? <>
                        <PreLoader></PreLoader>
                    </> :

                    <Form className="needs-validation" noValidate="" onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <Col sm="8">
                                <Row>
                                    <Col sm="12">
                                        <Card>
                                            <CardBody>
                                                <Row className="mb-3 align-items-center">
                                                    <Col md="6">
                                                        <div className="checkbox checkbox-dark">
                                                            <input id="use_rrp" type="checkbox"
                                                                checked={useRrp}
                                                                onChange={(e) => handleUseRrpChange(e.target.checked)}
                                                            />
                                                            <Label for="use_rrp">Use RRP price of product</Label>
                                                        </div>
                                                    </Col>
                                                    <Col md="6">
                                                        <div className="float-right" style={{width: 280}}>
                                                            <Select
                                                                options={CURRENCY_OPTIONS}
                                                                value={currency}
                                                                onChange={handleCurrencyChange}
                                                                placeholder="Select Currency"
                                                            />
                                                            {currency.value !== 'GBP' && (
                                                                <div className="text-right mt-1" style={{color: '#616161', fontSize: 12}}>
                                                                    Manual conversion rate (1 GBP = {currency.rate} {currency.value})
                                                                </div>
                                                            )}
                                                        </div>
                                                    </Col>
                                                </Row>

                                                {priceValid.length > 0 && <>
                                                <Alert color="danger">
                                                    <p>Product price must be greater than zero. These products can't be ordered.</p>
                                                    <ul style={priceAlertStyle}>
                                                        {priceValid.map(errorPrice =>                                                            
                                                            <li key={errorPrice.sku}>{errorPrice.sku}</li>
                                                        )}
                                                    </ul>
                                                </Alert>
                                                </>}

                                                
                                                {qtyValid.length > 0 && <>
                                                <Alert color="danger">
                                                    <p>The product quantity must be greater than zero and within the available stock. These products can't be ordered.</p>
                                                    <ul style={priceAlertStyle}>
                                                        {qtyValid.map(errorPrice =>                                                            
                                                            <li key={errorPrice.sku}>{errorPrice.sku}</li>
                                                        )}
                                                    </ul>
                                                </Alert>
                                                </>}

                                                <div className="form-row mb-3 ">
                                                    <Col md="12">
                                                        <FormGroup>
                                                            <Label className="col-form-label">Products</Label>
                                                            <Row>
                                                                <Col md="10 input-with-icon pr-1">
                                                                    <div>
                                                                        <FormGroup className="m-0">
                                                                            <i className="fa fa-search"></i>
                                                                            <input name="searchProduct" type="text"
                                                                                   placeholder="search Products"
                                                                                   ref={ref => {
                                                                                       searchProductRef.current = ref;
                                                                                   }}
                                                                                   onKeyUp={openSearchProductDialog}
                                                                                   className={`form-control`}/>
                                                                        </FormGroup>
                                                                    </div>
                                                                </Col>
                                                                <Col md="2 pl-0">
                                                                    <Button color="primary" type="button"
                                                                            className="btn btn-sm btn-primary btn-block"
                                                                            onClick={openSearchProductDialog}
                                                                            style={{height: 38}}>Browse</Button>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col md={12}>
                                                                    <OrderProductJqx setValue={setValue}
                                                                                     getValues={getValues}
                                                                                     trigger={trigger}
                                                                                     orderedProducts={getValues('ordered_products')}
                                                                                     setButtonDisable={setButtonDisable}
                                                                                     currency={currency}
                                                                                     useRrp={useRrp}
                                                                    ></OrderProductJqx>
                                                                </Col>
                                                            </Row>
                                                        </FormGroup>
                                                    </Col>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>

                                {getValues('ordered_products').length > 0 && <>
                                    <Row>
                                        <Col sm="12">
                                            <OrderPayment setValue={setValue} getValues={getValues} trigger={trigger} currencySymbol={currency.symbol}></OrderPayment>
                                            <div style={{color:'red',float:"right"}}>{errors.shipping?.message}</div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={12}>
                                            <Card>
                                                <CardBody>
                                                    <div className="float-right" style={{display:"flex"}}>
                                                        <div className="checkbox checkbox-dark mr-5">
                                                            <input id="is_paid" type="checkbox"  onChange={(e)=>{
                                                                      setValue('is_paid',e.target.checked)
                                                            }} defaultChecked={getValues('is_paid')}/>
                                                            <Label for="is_paid">Mark As Paid</Label>
                                                        </div>
                                                        <Button color="primary" value="1" type="submit" 
                                                            disabled={buttonDisable}>
                                                            {buttonLoading && <i className="fa fa-spinner fa-lg spinner mr-1" />} 
                                                            {getValues('id') ? 'Update Draft Order' : 'Create Draft Order'}
                                                        </Button>
                                                    </div>

                                                </CardBody>
                                            </Card>

                                        </Col>
                                    </Row>
                                </>}

                            </Col>
                            <Col sm="4">
                                <Row>
                                    <Col sm="12">
                                        <Card>
                                            <CardBody>
                                                <div className="form-row ">
                                                    <Col md="12">
                                                        <FormGroup>
                                                            <Label className="col-form-label">Customer</Label>

                                                            <AsyncSelect
                                                                className={` ${errors.customer ? 'is-invalid' : ''}`}
                                                                isClearable
                                                                cacheOptions
                                                                defaultOptions
                                                                defaultValue={getValues('customer')}
                                                                loadOptions={typePromiseOption}
                                                                onChange={(e) => {
                                                                    setValue('customer', e);
                                                                    trigger();

                                                                    getCustomerAddress(e);

                                                                }}

                                                            />
                                                            <div className="invalid-feedback">{errors.customer?.message}</div>
                                                        </FormGroup>
                                                    </Col>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                {getValues('customer')&&<Row>
                                    <Col sm="12">
                                        <Card>
                                            <CardBody>
                                                <Row>
                                                    <Col sm="6">
                                                        <Label style={{fontWeight: 'bold'}}>Shipping Address</Label>
                                                    </Col>
                                                    <Col sm="6">
                                                        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                                                            <a onClick={() => {
                                                                onEdit(getValues("shippingAddress").id,1);
                                                            }}><i className="fa fa-pencil"
                                                                  style={{
                                                                      width: 25,
                                                                      fontSize: 16,
                                                                      color: 'rgb(40, 167, 69)'
                                                                  }}></i></a>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm="6">
                                                        <label style={{fontWeight: "bolder"}}>First Name :</label>
                                                        <label style={{marginLeft: '5px'}}>{getValues("shippingAddress")?.first_name}</label>
                                                    </Col>
                                                    <Col sm="6">
                                                        <label style={{fontWeight: "bolder"}}>Last Name :</label>
                                                        <label style={{marginLeft: '5px'}}>{getValues("shippingAddress")?.last_name}</label>
                                                    </Col>
                                                    <Col sm="6">
                                                        <label style={{fontWeight: "bolder"}}>Address 1 :</label>
                                                        <label style={{marginLeft: '5px'}}>{getValues("shippingAddress")?.address1}</label>
                                                    </Col>
                                                    <Col sm="6">
                                                        <label style={{fontWeight: "bolder"}}>Address 2 :</label>
                                                        <label style={{marginLeft: '5px'}}>{getValues("shippingAddress")?.address2}</label>
                                                    </Col>
                                                    <Col sm="6">
                                                        <label style={{fontWeight: "bolder"}}>City :</label>
                                                        <label style={{marginLeft: '5px'}}>{getValues("shippingAddress")?.city}</label>
                                                    </Col>
                                                    <Col sm="6">
                                                        <label style={{fontWeight: "bolder"}}>Province :</label>
                                                        <label style={{marginLeft: '5px'}}>{getValues("shippingAddress")?.province}</label>
                                                    </Col>
                                                    <Col sm="6">
                                                        <label style={{fontWeight: "bolder"}}>Country :</label>
                                                        <label style={{marginLeft: '5px'}}>{ getValues("shippingAddress")?.country}</label>
                                                    </Col>
                                                    <Col sm="6">
                                                        <label style={{fontWeight: "bolder"}}>Zip :</label>
                                                        <label style={{marginLeft: '5px'}}>{getValues("shippingAddress")?.zip}</label>
                                                    </Col>
                                                </Row>


                                                <Row style={{marginTop: '20px'}}>
                                                    <Col sm="6">
                                                        <Label style={{fontWeight: 'bold'}}>Billing Address</Label>
                                                    </Col>
                                                    <Col sm="6">
                                                        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                                                            {! (isOjectEqual(getValues("shippingAddress"),getValues("billingAddress"))) && <a className="mr-3 btn btn-success btn-xs" onClick={sameAsShipping}>Same As Shipping</a>}
                                                            <a onClick={() => {
                                                                onEdit(getValues("billingAddress") ? getValues("billingAddress").id : 0,2);
                                                            }}><i className="fa fa-pencil"
                                                                  style={{
                                                                      width: 25,
                                                                      fontSize: 16,
                                                                      color: 'rgb(40, 167, 69)'
                                                                  }}></i></a>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={12}>

                                                        {isOjectEqual(getValues("shippingAddress"),getValues("billingAddress")) && <Label>Same As Shipping Address</Label>}

                                                    </Col>
                                                </Row>
                                                {!isOjectEqual(getValues("shippingAddress"),getValues("billingAddress"))  && <Row>



                                                            <Col sm="6">
                                                                <label style={{fontWeight: "bolder"}}>First Name :</label>
                                                                <label style={{marginLeft: '5px'}}>{getValues("billingAddress")?.first_name}</label>
                                                            </Col>
                                                            <Col sm="6">
                                                                <label style={{fontWeight: "bolder"}}>Last Name :</label>
                                                                <label style={{marginLeft: '5px'}}>{getValues("billingAddress")?.last_name}</label>
                                                            </Col>
                                                            <Col sm="6">
                                                                <label style={{fontWeight: "bolder"}}>Address 1 :</label>
                                                                <label style={{marginLeft: '5px'}}>{getValues("billingAddress")?.address1}</label>
                                                            </Col>
                                                            <Col sm="6">
                                                                <label style={{fontWeight: "bolder"}}>Address 2 :</label>
                                                                <label style={{marginLeft: '5px'}}>{getValues("billingAddress")?.address2}</label>
                                                            </Col>
                                                            <Col sm="6">
                                                                <label style={{fontWeight: "bolder"}}>City :</label>
                                                                <label style={{marginLeft: '5px'}}>{getValues("billingAddress")?.city}</label>
                                                            </Col>
                                                            <Col sm="6">
                                                                <label style={{fontWeight: "bolder"}}>Province :</label>
                                                                <label style={{marginLeft: '5px'}}>{getValues("billingAddress")?.province}</label>
                                                            </Col>
                                                            <Col sm="6">
                                                                <label style={{fontWeight: "bolder"}}>Country :</label>
                                                                <label style={{marginLeft: '5px'}}>{getValues("billingAddress")?.country}</label>
                                                            </Col>
                                                            <Col sm="6">
                                                                <label style={{fontWeight: "bolder"}}>Zip :</label>
                                                                <label style={{marginLeft: '5px'}}>{getValues("billingAddress")?.zip}</label>
                                                            </Col>
                                                </Row>}
                                            </CardBody>
                                        </Card>
                                    </Col>

                                </Row>}
                                <Row>
                                    <Col sm="12">
                                        <Card>
                                            <CardBody>
                                                <div className="form-row ">
                                                    <Col md="12">
                                                        <FormGroup>
                                                            <Label className="col-form-label">Notes</Label>
                                                            <input name="notes" type="text" {...register('notes')}
                                                                   className={`form-control`}/>
                                                        </FormGroup>
                                                    </Col>
                                                </div>
                                                {hasPriceChanged() && <div className="form-row ">
                                                    <Col md="12">
                                                        <FormGroup>
                                                            <Label className="col-form-label" style={{color: '#dc3545'}}>Price Change Reason <span style={{color: 'red'}}>*</span></Label>
                                                            <textarea name="price_change_reason" {...register('price_change_reason')}
                                                                   className={`form-control ${errors.price_change_reason ? 'is-invalid' : ''}`}
                                                                   rows={3}
                                                                   maxLength={200}
                                                                   placeholder="Enter reason why the price was changed..."/>
                                                            <div className="d-flex justify-content-between">
                                                                <div>{errors.price_change_reason && <span className="text-danger" style={{fontSize: 12}}>{errors.price_change_reason.message}</span>}</div>
                                                                <small className="text-muted">{(getValues('price_change_reason') || '').length}/200</small>
                                                            </div>
                                                        </FormGroup>
                                                    </Col>
                                                </div>}
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="12">
                                        <Card>
                                            <CardBody>
                                                <div className="form-row ">
                                                    <Col md="12">
                                                        <FormGroup>
                                                            <Label className="col-form-label">Tags</Label>
                                                            <TagsInput className="form-control tag-input-custom"
                                                                       onlyUnique={true} value={getValues('tags')}
                                                                       onChange={(value) => {
                                                                           // alert(JSON.stringify(value));
                                                                           setValue('tags', value)
                                                                           trigger('tags');
                                                                           // combineTags();
                                                                       }}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                    </Form>


                }
            </Container>
            <SearchProductModal setValue={setValue} getValues={getValues} trigger={trigger} currency={currency} useRrp={useRrp}></SearchProductModal>
            <OrderDiscount orderSetValue={setValue} orderTrigger={trigger}
                           orderGetValues={getValues}></OrderDiscount>
            <OrderShipment draftOrderState={draftOrderState} orderSetValue={setValue} orderTrigger={trigger}
                           orderGetValues={getValues}></OrderShipment>
            <OrderTax orderSetValue={setValue} orderTrigger={trigger}
                      orderGetValues={getValues}></OrderTax>

            <ModalFormSubmit
                defaultValues={defaultAddressValues}
                schema={addresSchema}
                onSubmitForm={onSubmitForm}
                reset={addressReset}
                formState={addressFormState}
                handleSubmit={addressHandleSubmit}
                title='Draft Order Address'
                selector='BuyerLead'
                dialog={draftOrderState.addressAddDialog}
                closeDialog={closeDialog}
                setValue={addressSetValue}
                getValues={addressRGetValues}
                isUseSelector
                size="xl"
                publish={false}
            >
                <DraftOrderAddressForm countries={draftOrderState.settings.countries} states={draftOrderState.settings.states || []} control={addressControl}
                                      formText="Buyer Lead Address" errors={addressErrors} register={addressRegister}
                                      setValue={addressSetValue}
                                      trigger={addressTrigger} getValues={addressRGetValues} addressArray={addressArray} add={add} setAddressData={setAddressData} type={type}/>
            </ModalFormSubmit>



        </Fragment>
    );

}

export default withReducer([
    {
        order: draftOrderReducer
    }
])(DraftOrderForm);